import React, { useEffect, useState } from 'react'
import Loader from 'react-loader-spinner'
import { getModal } from './modals'
import { ModalStore } from './modal-store'
import './modal-viewer.scss'

const WaitingModal = () => {
  return (
    <div>
      <Loader type="Oval" color="#ffffff" height={22} width={30} />
    </div>
  )
}
function getCurrentModalView() {
  if (!ModalStore.currentModal) {
    return null
  }
  return getModal(ModalStore.currentModal.id, ModalStore.currentModal.props)
}

export default function ModalViewer() {
  const [dirty, setDirty] = useState(1)
  useEffect(() => {
    // always update to last reference.
    ModalStore.onModalUpdate = () => {
      setDirty(dirty * -1)
      document.body.style.overflow = ModalStore.currentModal
        ? 'hidden'
        : 'initial'
    }
  })
  useEffect(() => {
    if (ModalStore.currentModal) {
      setTimeout(() => {
        let dialog: HTMLDialogElement | null = document.querySelector(
          'dialog.f-modal-viewer'
        )
        if (dialog) {
          dialog.showModal()
        }
      }, 100)
    }
  }, [dirty])

  if (!ModalStore.currentModal) {
    return null
  }

  return (
    <React.Suspense fallback={<WaitingModal />}>
      <dialog className="f-modal-viewer">
        <div className="f-modal-viewer__card slide-in-bck-bottom ">
          {getCurrentModalView()}
        </div>
      </dialog>
    </React.Suspense>
  )
}
